export default {
  cancelReasonLabel: 'Raison de l\'annulation (facultatif)',
};